import React, { memo } from 'react';
import { Link, navigate } from 'gatsby';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import arrowSvg from '../../../assets/images/arrow.svg';

const StyledFlexRow = styled.div`
  display: flex;
  flex-direction: row;
`;

const StyledArrow = styled.img`
  flex-basis: 20px;
  height: auto;
  align-self: center;
  margin-left: 15px;
  filter: ${(props) => (props.invert ? 'invert(1)' : 'invert(0.5)')};
`;

const StyledText = styled.p`
  height: 22px;
  max-width: 170px;
  font-family: AvenirMedium;
  font-size: 14px;
  letter-spacing: 0.12px;
  line-height: 22px;
  margin: 0;
  color: ${(props) => (props.textColor ? props.textColor : '#8d848d')};
`;

const StyledLink = styled(Link)`
  text-decoration: none !important;
  color: unset;
`;

const BasicButtonComponent = ({ text, to, textColor, invert }) => (
  <StyledFlexRow>
    <StyledText textColor={textColor}>{text}</StyledText>
    <StyledArrow src={arrowSvg} invert={invert} />
  </StyledFlexRow>
);

const BasicButton = memo(BasicButtonComponent);

BasicButton.defaultProps = {
  text: 'Read More',
  invert: false,
};

BasicButton.propTypes = {
  text: PropTypes.string,
  invert: PropTypes.bool,
};

export { BasicButton };
